import { render, staticRenderFns } from "./ProjectsCreate.vue?vue&type=template&id=251df761&"
import script from "./ProjectsCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports